import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import useHeadingStyles from "hooks/useHeadingStyles"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()(
  (theme) => ({
    bio: {
      margin: "20px 0",
      color: "#262B2D",
      fontFamily: "Lato",
      fontSize: "16px",
      letterSpacing: 0,
      lineHeight: "22px",
      whiteSpace: "pre-wrap",
      [theme.breakpoints.up("md")]: {
        marginRight: "125px",
      },
    },
    customButton: {
      fontSize: "18px",
      color: "#1976D2",
      fontFamily: "Lato",
      letterSpacing: "0.3px",
      lineHeight: "22px",
      fontWeight: "bold",
    },
    parentDiv: {
      height: "40px",
      minWidth: "80px",
      borderRadius: "5px",
      marginBottom: "20px",
      justifyContent: "left",
    },
  })
)

interface IProfile {
  bio: string
  callToActionName: string
  callToActionUrl: string
  callToActionUrlLabel: string
}

const Profile = (props: IProfile) => {
  const { bio, callToActionName, callToActionUrl, callToActionUrlLabel } = props

  const { classes } = useStyles()

  const { classes: headingClasses } = useHeadingStyles()

  return (
    <>
      <Typography variant="h5" className={headingClasses.h5}>
        Organization Bio
      </Typography>
      <Typography className={classes.bio}>{bio}</Typography>
      {callToActionName && (
        <IconButton
          className={classes.parentDiv}
          href={callToActionUrl}
          target="_blank"
          aria-label={callToActionUrlLabel}
          size="large">
          <Typography variant="h5" className={classes.customButton}>
            {callToActionName}
          </Typography>
        </IconButton>
      )}
    </>
  )
}

export default Profile
